import React, { useEffect, useMemo } from 'react';
import './style.css';
import { useLocation } from 'react-router';
import qs from 'query-string';
import UnsubscribeFailure from './UnsubscribeFailure';
import { useUnsubscribeStore } from './store';
import ResubscribeSuccess from './ResubscribeSuccess';
import UnsubscribeSuccess from './UnsubscribeSuccess';

export default function Unsubscribe() {
  const { search } = useLocation(),
    { ui: token, failure, emailTypeId } = qs.parse(search);
  const {
    resubscribed,
    setCurrentToken,
    setCurrentEmailTypeId,
  } = useUnsubscribeStore();
  useEffect(() => {
    setCurrentToken(token);
    setCurrentEmailTypeId(emailTypeId);
  }, [token, emailTypeId]);
  const innerComponent = useMemo(() => {
    if (failure) return <UnsubscribeFailure />;
    if (resubscribed) return <ResubscribeSuccess />;
    return <UnsubscribeSuccess />;
  }, [failure, resubscribed]);
  return (
    <div className="flex items-center" style={{ flexDirection: 'column' }}>
      <div className="unsubscribe-body">{innerComponent}</div>
    </div>
  );
}
